import React, { useState } from 'react';
import { useGoals, goalTemplates, motivationalQuotes, weeklyQuestions } from './hooks/useGoals';
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import GoalModal from './components/GoalModal';
import Footer from './components/Footer';

function App() {
  const {
    goals,
    addGoal,
    updateGoal,
    deleteGoal,
    toggleMilestone,
    addCheckin,
    getGoalProgress,
    getOverallStats,
    getTimelineEvents
  } = useGoals();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingGoal, setEditingGoal] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const stats = getOverallStats();
  const timelineEvents = getTimelineEvents();

  const handleCreateGoal = () => {
    setEditingGoal(null);
    setSelectedTemplate(null);
    setIsModalOpen(true);
  };

  const handleEditGoal = (goal) => {
    setEditingGoal(goal);
    setSelectedTemplate(null);
    setIsModalOpen(true);
  };

  const handleUseTemplate = (template) => {
    setEditingGoal(null);
    setSelectedTemplate(template);
    setIsModalOpen(true);
  };

  const handleSaveGoal = (goalData) => {
    if (editingGoal) {
      updateGoal(editingGoal.id, goalData);
    } else {
      addGoal(goalData);
    }
    setIsModalOpen(false);
    setEditingGoal(null);
    setSelectedTemplate(null);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingGoal(null);
    setSelectedTemplate(null);
  };

  return (
    <div className="app">
      <Header stats={stats} />

      <main className="main-content">
        <Dashboard
          goals={goals}
          stats={stats}
          timelineEvents={timelineEvents}
          getGoalProgress={getGoalProgress}
          onCreateGoal={handleCreateGoal}
          onEditGoal={handleEditGoal}
          onDeleteGoal={deleteGoal}
          onToggleMilestone={toggleMilestone}
          onCheckin={addCheckin}
        />
      </main>

      <Footer
        templates={goalTemplates}
        quotes={motivationalQuotes}
        onUseTemplate={handleUseTemplate}
      />

      {isModalOpen && (
        <GoalModal
          goal={editingGoal}
          template={selectedTemplate}
          onSave={handleSaveGoal}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
}

export default App;
